// Deterministic safety check badge rendered above the ActionHintStrip.
// Extracted from DecisionEnginePage.js during Phase 1 consolidation —
// no logic or visual changes.
import React from 'react';

export const VALIDATION_STYLE = {
  safe: 'bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-900',
  caution: 'bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-900',
  conflict: 'bg-red-100 text-red-800 border-red-200 dark:bg-red-950/40 dark:text-red-300 dark:border-red-900',
};

export const VALIDATION_LABEL = {
  safe: 'Safe',
  caution: 'Caution',
  conflict: 'Conflict',
};

export const DecisionValidationBadge = ({ validation }) => {
  if (!validation || !validation.status) return null;
  const cls = VALIDATION_STYLE[validation.status] || VALIDATION_STYLE.safe;
  const label = VALIDATION_LABEL[validation.status] || 'Safe';
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-[11px] font-medium ${cls}`}
      data-testid="decision-validation-badge"
      data-status={validation.status}
      aria-label={`Decision validation: ${label}`}
    >
      <span className="font-semibold uppercase tracking-wide" data-testid="decision-validation-status">{label}</span>
      {validation.message && (
        <span className="font-normal" data-testid="decision-validation-message">: {validation.message}</span>
      )}
    </span>
  );
};
